import ApiService from '../api.services';

const UnitService = {
    list: async function () {
        try {
            const response = await ApiService.get('/api/units');
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    get: async function (id) {
        try {
            const response = await ApiService.get(`/api/units/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    add: async function (form) {
        const data = {
            unit: form
        }
        try {
            const response = await ApiService.post('/api/units', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    update: async function (id, form) {
        const data = {
            unit: form
        }
        try {
            const response = await ApiService.put(`/api/units/${id}`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    delete: async function (id) {
        try {
            const response = await ApiService.delete(`/api/units/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default UnitService;

export { UnitService };

